// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_documentapis__Buhta_document_v1alpha1_document_batch from "./buhta_document_v1alpha1_document_batch.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetBatchRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_batch_service.ml",
      1497,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetBatchResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_batch_service.ml",
      1560,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListBatchesRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_batch_service.ml",
      1620,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListBatchesResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_batch_service.ml",
      1680,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateBatchRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_batch_service.ml",
      1740,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateBatchResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_batch_service.ml",
      1800,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateBatchRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_batch_service.ml",
      1861,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateBatchResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_batch_service.ml",
      1924,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const DeleteBatchRequest = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_batch_service.ml",
      1984,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const DeleteBatchResponse = Caml_module.init_mod([
      "proto/documentapis/gen/buhta_edo_document_v1alpha1_document_batch_service.ml",
      2042,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.edo.document.v1alpha1.GetBatchRequest";
}

function make(idOpt, expandOpt, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  return {
          id: id,
          expand: expand
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            2,
            "expand",
            "expand"
          ],
          Ocaml_protoc_plugin__Spec.string,
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          expand: Curry._2(merge_expand, t1.expand, t2.expand)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                      [
                        2,
                        "expand",
                        "expand"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      Ocaml_protoc_plugin__Spec.not_packed
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.id, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, expand) {
  return {
          id: id,
          expand: expand
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.GetBatchRequest", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.expand);
  };
}

function constructor$1(id, expand) {
  return {
          id: id,
          expand: expand
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.GetBatchRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetBatchRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.edo.document.v1alpha1.GetBatchResponse";
}

function make$1(batch, param) {
  return {
          batch: batch
        };
}

const $$let = Buhta_documentapis__Buhta_document_v1alpha1_document_batch.Buhta.$$Document.V1alpha1.DocumentBatch;

const merge_batch = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "batch",
            "batch"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          batch: Curry._2(merge_batch, t1.batch, t2.batch)
        };
}

function spec$1(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_document_batch.Buhta.$$Document.V1alpha1.DocumentBatch;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "batch",
                    "batch"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.batch);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(batch) {
  return {
          batch: batch
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.GetBatchResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.batch);
  };
}

function constructor$3(batch) {
  return {
          batch: batch
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.GetBatchResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetBatchResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.edo.document.v1alpha1.ListBatchesRequest";
}

function make$2(grid, param) {
  return {
          grid: grid
        };
}

const $$let$1 = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "grid",
            "grid"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

function merge$2(t1, t2) {
  return {
          grid: Curry._2(merge_grid, t1.grid, t2.grid)
        };
}

function spec$2(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "grid",
                    "grid"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._2(serialize$2, writer, param.grid);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(grid) {
  return {
          grid: grid
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.ListBatchesRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.grid);
  };
}

function constructor$5(grid) {
  return {
          grid: grid
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.ListBatchesRequest", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListBatchesRequest, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.edo.document.v1alpha1.ListBatchesResponse";
}

function make$3(batchesOpt, param) {
  const batches = batchesOpt !== undefined ? batchesOpt : /* [] */0;
  return {
          batches: batches
        };
}

const $$let$2 = Buhta_documentapis__Buhta_document_v1alpha1_document_batch.Buhta.$$Document.V1alpha1.DocumentBatch;

const merge_batches = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "batches",
            "batches"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$3(t1, t2) {
  return {
          batches: Curry._2(merge_batches, t1.batches, t2.batches)
        };
}

function spec$3(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_document_batch.Buhta.$$Document.V1alpha1.DocumentBatch;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "batches",
                    "batches"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.batches);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(batches) {
  return {
          batches: batches
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.ListBatchesResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.batches);
  };
}

function constructor$7(batches) {
  return {
          batches: batches
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.ListBatchesResponse", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListBatchesResponse, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

function name$4(param) {
  return ".buhta.edo.document.v1alpha1.CreateBatchRequest";
}

function make$4(batch, param) {
  return {
          batch: batch
        };
}

const $$let$3 = Buhta_documentapis__Buhta_document_v1alpha1_document_batch.Buhta.$$Document.V1alpha1.DocumentBatch;

const merge_batch$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "batch",
            "batch"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

function merge$4(t1, t2) {
  return {
          batch: Curry._2(merge_batch$1, t1.batch, t2.batch)
        };
}

function spec$4(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_document_batch.Buhta.$$Document.V1alpha1.DocumentBatch;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "batch",
                    "batch"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
    });

function to_proto$p$4(writer, param) {
  Curry._2(serialize$4, writer, param.batch);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(batch) {
  return {
          batch: batch
        };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
    });

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$4, writer);
            });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.CreateBatchRequest", spec$4(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.batch);
  };
}

function constructor$9(batch) {
  return {
          batch: batch
        };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.CreateBatchRequest", spec$4(undefined), constructor$9);
    });

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$4, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateBatchRequest, {
      make: make$4,
      to_proto: to_proto$4,
      from_proto: from_proto$4,
      to_json: to_json$4,
      from_json: from_json$4,
      name: name$4,
      merge: merge$4,
      to_proto$p: to_proto$p$4,
      from_proto_exn: from_proto_exn$4,
      from_json_exn: from_json_exn$4
    });

function name$5(param) {
  return ".buhta.edo.document.v1alpha1.CreateBatchResponse";
}

function make$5(batch, param) {
  return {
          batch: batch
        };
}

const $$let$4 = Buhta_documentapis__Buhta_document_v1alpha1_document_batch.Buhta.$$Document.V1alpha1.DocumentBatch;

const merge_batch$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "batch",
            "batch"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$4.name,
                make: $$let$4.make,
                from_proto: $$let$4.from_proto,
                from_proto_exn: $$let$4.from_proto_exn,
                to_proto: $$let$4.to_proto,
                to_proto$p: $$let$4.to_proto$p,
                merge: $$let$4.merge,
                to_json: $$let$4.to_json,
                from_json_exn: $$let$4.from_json_exn,
                from_json: $$let$4.from_json
              })
        ]));

function merge$5(t1, t2) {
  return {
          batch: Curry._2(merge_batch$2, t1.batch, t2.batch)
        };
}

function spec$5(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_document_batch.Buhta.$$Document.V1alpha1.DocumentBatch;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "batch",
                    "batch"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
    });

function to_proto$p$5(writer, param) {
  Curry._2(serialize$5, writer, param.batch);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(batch) {
  return {
          batch: batch
        };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
    });

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$5, writer);
            });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.CreateBatchResponse", spec$5(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.batch);
  };
}

function constructor$11(batch) {
  return {
          batch: batch
        };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.CreateBatchResponse", spec$5(undefined), constructor$11);
    });

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$5, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateBatchResponse, {
      make: make$5,
      to_proto: to_proto$5,
      from_proto: from_proto$5,
      to_json: to_json$5,
      from_json: from_json$5,
      name: name$5,
      merge: merge$5,
      to_proto$p: to_proto$p$5,
      from_proto_exn: from_proto_exn$5,
      from_json_exn: from_json_exn$5
    });

function name$6(param) {
  return ".buhta.edo.document.v1alpha1.UpdateBatchRequest";
}

function make$6(idOpt, batch, param) {
  const id = idOpt !== undefined ? idOpt : "";
  return {
          id: id,
          batch: batch
        };
}

const merge_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let$5 = Buhta_documentapis__Buhta_document_v1alpha1_document_batch.Buhta.$$Document.V1alpha1.DocumentBatch;

const merge_batch$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "batch",
            "batch"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$5.name,
                make: $$let$5.make,
                from_proto: $$let$5.from_proto,
                from_proto_exn: $$let$5.from_proto_exn,
                to_proto: $$let$5.to_proto,
                to_proto$p: $$let$5.to_proto$p,
                merge: $$let$5.merge,
                to_json: $$let$5.to_json,
                from_json_exn: $$let$5.from_json_exn,
                from_json: $$let$5.from_json
              })
        ]));

function merge$6(t1, t2) {
  return {
          id: Curry._2(merge_id$1, t1.id, t2.id),
          batch: Curry._2(merge_batch$3, t1.batch, t2.batch)
        };
}

function spec$6(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_document_batch.Buhta.$$Document.V1alpha1.DocumentBatch;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "batch",
                        "batch"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: $$let.name,
                            make: $$let.make,
                            from_proto: $$let.from_proto,
                            from_proto_exn: $$let.from_proto_exn,
                            to_proto: $$let.to_proto,
                            to_proto$p: $$let.to_proto$p,
                            merge: $$let.merge,
                            to_json: $$let.to_json,
                            from_json_exn: $$let.from_json_exn,
                            from_json: $$let.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
    });

function to_proto$p$6(writer, param) {
  Curry._3(serialize$6, writer, param.id, param.batch);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$12(id, batch) {
  return {
          id: id,
          batch: batch
        };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
    });

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$6, writer);
            });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.UpdateBatchRequest", spec$6(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.batch);
  };
}

function constructor$13(id, batch) {
  return {
          id: id,
          batch: batch
        };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.UpdateBatchRequest", spec$6(undefined), constructor$13);
    });

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$6, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateBatchRequest, {
      make: make$6,
      to_proto: to_proto$6,
      from_proto: from_proto$6,
      to_json: to_json$6,
      from_json: from_json$6,
      name: name$6,
      merge: merge$6,
      to_proto$p: to_proto$p$6,
      from_proto_exn: from_proto_exn$6,
      from_json_exn: from_json_exn$6
    });

function name$7(param) {
  return ".buhta.edo.document.v1alpha1.UpdateBatchResponse";
}

function make$7(batch, param) {
  return {
          batch: batch
        };
}

const $$let$6 = Buhta_documentapis__Buhta_document_v1alpha1_document_batch.Buhta.$$Document.V1alpha1.DocumentBatch;

const merge_batch$4 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "batch",
            "batch"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$6.name,
                make: $$let$6.make,
                from_proto: $$let$6.from_proto,
                from_proto_exn: $$let$6.from_proto_exn,
                to_proto: $$let$6.to_proto,
                to_proto$p: $$let$6.to_proto$p,
                merge: $$let$6.merge,
                to_json: $$let$6.to_json,
                from_json_exn: $$let$6.from_json_exn,
                from_json: $$let$6.from_json
              })
        ]));

function merge$7(t1, t2) {
  return {
          batch: Curry._2(merge_batch$4, t1.batch, t2.batch)
        };
}

function spec$7(param) {
  const $$let = Buhta_documentapis__Buhta_document_v1alpha1_document_batch.Buhta.$$Document.V1alpha1.DocumentBatch;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "batch",
                    "batch"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
    });

function to_proto$p$7(writer, param) {
  Curry._2(serialize$7, writer, param.batch);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$14(batch) {
  return {
          batch: batch
        };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
    });

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$7, writer);
            });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.UpdateBatchResponse", spec$7(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.batch);
  };
}

function constructor$15(batch) {
  return {
          batch: batch
        };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.UpdateBatchResponse", spec$7(undefined), constructor$15);
    });

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$7, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateBatchResponse, {
      make: make$7,
      to_proto: to_proto$7,
      from_proto: from_proto$7,
      to_json: to_json$7,
      from_json: from_json$7,
      name: name$7,
      merge: merge$7,
      to_proto$p: to_proto$p$7,
      from_proto_exn: from_proto_exn$7,
      from_json_exn: from_json_exn$7
    });

function name$8(param) {
  return ".buhta.edo.document.v1alpha1.DeleteBatchRequest";
}

function make$8(idOpt, param) {
  const id = idOpt !== undefined ? idOpt : "";
  return {
          id: id
        };
}

const merge_id$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$8(t1, t2) {
  return {
          id: Curry._2(merge_id$2, t1.id, t2.id)
        };
}

function spec$8(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$8(undefined));
    });

function to_proto$p$8(writer, param) {
  Curry._2(serialize$8, writer, param.id);
}

function to_proto$8(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$8(writer, t);
  return writer;
}

function constructor$16(id) {
  return {
          id: id
        };
}

const from_proto_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$8(undefined), constructor$16);
    });

function from_proto$8(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$8, writer);
            });
}

function to_json$8(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.DeleteBatchRequest", spec$8(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.id);
  };
}

function constructor$17(id) {
  return {
          id: id
        };
}

const from_json_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.DeleteBatchRequest", spec$8(undefined), constructor$17);
    });

function from_json$8(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$8, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, DeleteBatchRequest, {
      make: make$8,
      to_proto: to_proto$8,
      from_proto: from_proto$8,
      to_json: to_json$8,
      from_json: from_json$8,
      name: name$8,
      merge: merge$8,
      to_proto$p: to_proto$p$8,
      from_proto_exn: from_proto_exn$8,
      from_json_exn: from_json_exn$8
    });

function name$9(param) {
  return ".buhta.edo.document.v1alpha1.DeleteBatchResponse";
}

function make$9(param) {
  
}

function merge$9(param, param$1) {
  
}

const serialize$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(Ocaml_protoc_plugin__Spec.nil);
    });

function to_proto$p$9(writer, param) {
  Curry._1(serialize$9, writer);
}

function to_proto$9(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._1(serialize$9, writer);
  return writer;
}

const from_proto_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(Ocaml_protoc_plugin__Spec.nil, undefined);
    });

function from_proto$9(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              Curry._1(from_proto_exn$9, writer);
            });
}

function to_json$9(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.edo.document.v1alpha1.DeleteBatchResponse", Ocaml_protoc_plugin__Spec.nil)(options);
  return function (param) {
    return serialize;
  };
}

const from_json_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.edo.document.v1alpha1.DeleteBatchResponse", Ocaml_protoc_plugin__Spec.nil, undefined);
    });

function from_json$9(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              Curry._1(from_json_exn$9, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, DeleteBatchResponse, {
      make: make$9,
      to_proto: to_proto$9,
      from_proto: from_proto$9,
      to_json: to_json$9,
      from_json: from_json$9,
      name: name$9,
      merge: merge$9,
      to_proto$p: to_proto$p$9,
      from_proto_exn: from_proto_exn$9,
      from_json_exn: from_json_exn$9
    });

const getBatch_0 = {
  name: GetBatchRequest.name,
  make: GetBatchRequest.make,
  from_proto: GetBatchRequest.from_proto,
  from_proto_exn: GetBatchRequest.from_proto_exn,
  to_proto: GetBatchRequest.to_proto,
  to_proto$p: GetBatchRequest.to_proto$p,
  merge: GetBatchRequest.merge,
  to_json: GetBatchRequest.to_json,
  from_json_exn: GetBatchRequest.from_json_exn,
  from_json: GetBatchRequest.from_json
};

const getBatch_1 = {
  name: GetBatchResponse.name,
  make: GetBatchResponse.make,
  from_proto: GetBatchResponse.from_proto,
  from_proto_exn: GetBatchResponse.from_proto_exn,
  to_proto: GetBatchResponse.to_proto,
  to_proto$p: GetBatchResponse.to_proto$p,
  merge: GetBatchResponse.merge,
  to_json: GetBatchResponse.to_json,
  from_json_exn: GetBatchResponse.from_json_exn,
  from_json: GetBatchResponse.from_json
};

const getBatch = [
  getBatch_0,
  getBatch_1
];

const listBatches_0 = {
  name: ListBatchesRequest.name,
  make: ListBatchesRequest.make,
  from_proto: ListBatchesRequest.from_proto,
  from_proto_exn: ListBatchesRequest.from_proto_exn,
  to_proto: ListBatchesRequest.to_proto,
  to_proto$p: ListBatchesRequest.to_proto$p,
  merge: ListBatchesRequest.merge,
  to_json: ListBatchesRequest.to_json,
  from_json_exn: ListBatchesRequest.from_json_exn,
  from_json: ListBatchesRequest.from_json
};

const listBatches_1 = {
  name: ListBatchesResponse.name,
  make: ListBatchesResponse.make,
  from_proto: ListBatchesResponse.from_proto,
  from_proto_exn: ListBatchesResponse.from_proto_exn,
  to_proto: ListBatchesResponse.to_proto,
  to_proto$p: ListBatchesResponse.to_proto$p,
  merge: ListBatchesResponse.merge,
  to_json: ListBatchesResponse.to_json,
  from_json_exn: ListBatchesResponse.from_json_exn,
  from_json: ListBatchesResponse.from_json
};

const listBatches = [
  listBatches_0,
  listBatches_1
];

const createBatch_0 = {
  name: CreateBatchRequest.name,
  make: CreateBatchRequest.make,
  from_proto: CreateBatchRequest.from_proto,
  from_proto_exn: CreateBatchRequest.from_proto_exn,
  to_proto: CreateBatchRequest.to_proto,
  to_proto$p: CreateBatchRequest.to_proto$p,
  merge: CreateBatchRequest.merge,
  to_json: CreateBatchRequest.to_json,
  from_json_exn: CreateBatchRequest.from_json_exn,
  from_json: CreateBatchRequest.from_json
};

const createBatch_1 = {
  name: CreateBatchResponse.name,
  make: CreateBatchResponse.make,
  from_proto: CreateBatchResponse.from_proto,
  from_proto_exn: CreateBatchResponse.from_proto_exn,
  to_proto: CreateBatchResponse.to_proto,
  to_proto$p: CreateBatchResponse.to_proto$p,
  merge: CreateBatchResponse.merge,
  to_json: CreateBatchResponse.to_json,
  from_json_exn: CreateBatchResponse.from_json_exn,
  from_json: CreateBatchResponse.from_json
};

const createBatch = [
  createBatch_0,
  createBatch_1
];

const updateBatch_0 = {
  name: UpdateBatchRequest.name,
  make: UpdateBatchRequest.make,
  from_proto: UpdateBatchRequest.from_proto,
  from_proto_exn: UpdateBatchRequest.from_proto_exn,
  to_proto: UpdateBatchRequest.to_proto,
  to_proto$p: UpdateBatchRequest.to_proto$p,
  merge: UpdateBatchRequest.merge,
  to_json: UpdateBatchRequest.to_json,
  from_json_exn: UpdateBatchRequest.from_json_exn,
  from_json: UpdateBatchRequest.from_json
};

const updateBatch_1 = {
  name: UpdateBatchResponse.name,
  make: UpdateBatchResponse.make,
  from_proto: UpdateBatchResponse.from_proto,
  from_proto_exn: UpdateBatchResponse.from_proto_exn,
  to_proto: UpdateBatchResponse.to_proto,
  to_proto$p: UpdateBatchResponse.to_proto$p,
  merge: UpdateBatchResponse.merge,
  to_json: UpdateBatchResponse.to_json,
  from_json_exn: UpdateBatchResponse.from_json_exn,
  from_json: UpdateBatchResponse.from_json
};

const updateBatch = [
  updateBatch_0,
  updateBatch_1
];

const deleteBatch_0 = {
  name: DeleteBatchRequest.name,
  make: DeleteBatchRequest.make,
  from_proto: DeleteBatchRequest.from_proto,
  from_proto_exn: DeleteBatchRequest.from_proto_exn,
  to_proto: DeleteBatchRequest.to_proto,
  to_proto$p: DeleteBatchRequest.to_proto$p,
  merge: DeleteBatchRequest.merge,
  to_json: DeleteBatchRequest.to_json,
  from_json_exn: DeleteBatchRequest.from_json_exn,
  from_json: DeleteBatchRequest.from_json
};

const deleteBatch_1 = {
  name: DeleteBatchResponse.name,
  make: DeleteBatchResponse.make,
  from_proto: DeleteBatchResponse.from_proto,
  from_proto_exn: DeleteBatchResponse.from_proto_exn,
  to_proto: DeleteBatchResponse.to_proto,
  to_proto$p: DeleteBatchResponse.to_proto$p,
  merge: DeleteBatchResponse.merge,
  to_json: DeleteBatchResponse.to_json,
  from_json_exn: DeleteBatchResponse.from_json_exn,
  from_json: DeleteBatchResponse.from_json
};

const deleteBatch = [
  deleteBatch_0,
  deleteBatch_1
];

const V1alpha1_DocumentBatchService = {
  GetBatch: {
    name: "/buhta.edo.document.v1alpha1.DocumentBatchService/GetBatch",
    package_name: "buhta.edo.document.v1alpha1",
    service_name: "DocumentBatchService",
    method_name: "GetBatch",
    $$Request: {
      name: GetBatchRequest.name,
      make: GetBatchRequest.make,
      from_proto: GetBatchRequest.from_proto,
      from_proto_exn: GetBatchRequest.from_proto_exn,
      to_proto: GetBatchRequest.to_proto,
      to_proto$p: GetBatchRequest.to_proto$p,
      merge: GetBatchRequest.merge,
      to_json: GetBatchRequest.to_json,
      from_json_exn: GetBatchRequest.from_json_exn,
      from_json: GetBatchRequest.from_json
    },
    $$Response: {
      name: GetBatchResponse.name,
      make: GetBatchResponse.make,
      from_proto: GetBatchResponse.from_proto,
      from_proto_exn: GetBatchResponse.from_proto_exn,
      to_proto: GetBatchResponse.to_proto,
      to_proto$p: GetBatchResponse.to_proto$p,
      merge: GetBatchResponse.merge,
      to_json: GetBatchResponse.to_json,
      from_json_exn: GetBatchResponse.from_json_exn,
      from_json: GetBatchResponse.from_json
    }
  },
  getBatch: getBatch,
  ListBatches: {
    name: "/buhta.edo.document.v1alpha1.DocumentBatchService/ListBatches",
    package_name: "buhta.edo.document.v1alpha1",
    service_name: "DocumentBatchService",
    method_name: "ListBatches",
    $$Request: {
      name: ListBatchesRequest.name,
      make: ListBatchesRequest.make,
      from_proto: ListBatchesRequest.from_proto,
      from_proto_exn: ListBatchesRequest.from_proto_exn,
      to_proto: ListBatchesRequest.to_proto,
      to_proto$p: ListBatchesRequest.to_proto$p,
      merge: ListBatchesRequest.merge,
      to_json: ListBatchesRequest.to_json,
      from_json_exn: ListBatchesRequest.from_json_exn,
      from_json: ListBatchesRequest.from_json
    },
    $$Response: {
      name: ListBatchesResponse.name,
      make: ListBatchesResponse.make,
      from_proto: ListBatchesResponse.from_proto,
      from_proto_exn: ListBatchesResponse.from_proto_exn,
      to_proto: ListBatchesResponse.to_proto,
      to_proto$p: ListBatchesResponse.to_proto$p,
      merge: ListBatchesResponse.merge,
      to_json: ListBatchesResponse.to_json,
      from_json_exn: ListBatchesResponse.from_json_exn,
      from_json: ListBatchesResponse.from_json
    }
  },
  listBatches: listBatches,
  CreateBatch: {
    name: "/buhta.edo.document.v1alpha1.DocumentBatchService/CreateBatch",
    package_name: "buhta.edo.document.v1alpha1",
    service_name: "DocumentBatchService",
    method_name: "CreateBatch",
    $$Request: {
      name: CreateBatchRequest.name,
      make: CreateBatchRequest.make,
      from_proto: CreateBatchRequest.from_proto,
      from_proto_exn: CreateBatchRequest.from_proto_exn,
      to_proto: CreateBatchRequest.to_proto,
      to_proto$p: CreateBatchRequest.to_proto$p,
      merge: CreateBatchRequest.merge,
      to_json: CreateBatchRequest.to_json,
      from_json_exn: CreateBatchRequest.from_json_exn,
      from_json: CreateBatchRequest.from_json
    },
    $$Response: {
      name: CreateBatchResponse.name,
      make: CreateBatchResponse.make,
      from_proto: CreateBatchResponse.from_proto,
      from_proto_exn: CreateBatchResponse.from_proto_exn,
      to_proto: CreateBatchResponse.to_proto,
      to_proto$p: CreateBatchResponse.to_proto$p,
      merge: CreateBatchResponse.merge,
      to_json: CreateBatchResponse.to_json,
      from_json_exn: CreateBatchResponse.from_json_exn,
      from_json: CreateBatchResponse.from_json
    }
  },
  createBatch: createBatch,
  UpdateBatch: {
    name: "/buhta.edo.document.v1alpha1.DocumentBatchService/UpdateBatch",
    package_name: "buhta.edo.document.v1alpha1",
    service_name: "DocumentBatchService",
    method_name: "UpdateBatch",
    $$Request: {
      name: UpdateBatchRequest.name,
      make: UpdateBatchRequest.make,
      from_proto: UpdateBatchRequest.from_proto,
      from_proto_exn: UpdateBatchRequest.from_proto_exn,
      to_proto: UpdateBatchRequest.to_proto,
      to_proto$p: UpdateBatchRequest.to_proto$p,
      merge: UpdateBatchRequest.merge,
      to_json: UpdateBatchRequest.to_json,
      from_json_exn: UpdateBatchRequest.from_json_exn,
      from_json: UpdateBatchRequest.from_json
    },
    $$Response: {
      name: UpdateBatchResponse.name,
      make: UpdateBatchResponse.make,
      from_proto: UpdateBatchResponse.from_proto,
      from_proto_exn: UpdateBatchResponse.from_proto_exn,
      to_proto: UpdateBatchResponse.to_proto,
      to_proto$p: UpdateBatchResponse.to_proto$p,
      merge: UpdateBatchResponse.merge,
      to_json: UpdateBatchResponse.to_json,
      from_json_exn: UpdateBatchResponse.from_json_exn,
      from_json: UpdateBatchResponse.from_json
    }
  },
  updateBatch: updateBatch,
  DeleteBatch: {
    name: "/buhta.edo.document.v1alpha1.DocumentBatchService/DeleteBatch",
    package_name: "buhta.edo.document.v1alpha1",
    service_name: "DocumentBatchService",
    method_name: "DeleteBatch",
    $$Request: {
      name: DeleteBatchRequest.name,
      make: DeleteBatchRequest.make,
      from_proto: DeleteBatchRequest.from_proto,
      from_proto_exn: DeleteBatchRequest.from_proto_exn,
      to_proto: DeleteBatchRequest.to_proto,
      to_proto$p: DeleteBatchRequest.to_proto$p,
      merge: DeleteBatchRequest.merge,
      to_json: DeleteBatchRequest.to_json,
      from_json_exn: DeleteBatchRequest.from_json_exn,
      from_json: DeleteBatchRequest.from_json
    },
    $$Response: {
      name: DeleteBatchResponse.name,
      make: DeleteBatchResponse.make,
      from_proto: DeleteBatchResponse.from_proto,
      from_proto_exn: DeleteBatchResponse.from_proto_exn,
      to_proto: DeleteBatchResponse.to_proto,
      to_proto$p: DeleteBatchResponse.to_proto$p,
      merge: DeleteBatchResponse.merge,
      to_json: DeleteBatchResponse.to_json,
      from_json_exn: DeleteBatchResponse.from_json_exn,
      from_json: DeleteBatchResponse.from_json
    }
  },
  deleteBatch: deleteBatch
};

const V1alpha1 = {
  GetBatchRequest: GetBatchRequest,
  GetBatchResponse: GetBatchResponse,
  ListBatchesRequest: ListBatchesRequest,
  ListBatchesResponse: ListBatchesResponse,
  CreateBatchRequest: CreateBatchRequest,
  CreateBatchResponse: CreateBatchResponse,
  UpdateBatchRequest: UpdateBatchRequest,
  UpdateBatchResponse: UpdateBatchResponse,
  DeleteBatchRequest: DeleteBatchRequest,
  DeleteBatchResponse: DeleteBatchResponse,
  DocumentBatchService: V1alpha1_DocumentBatchService
};

const $$Document = {
  V1alpha1: V1alpha1
};

const Edo = {
  $$Document: $$Document
};

const Buhta = {
  Edo: Edo
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* GetBatchRequest Not a pure module */
